
<div class="kz-post"
     #kzPost
     [attr.data-post-type]="(post.type==postTypePicture && !post.atHome)?'idea':post.type"
     [attr.data-empty-pictures]="!post.medias.length"
     [class.kz-post--schedule]="((post.createdAt | dfnsParseIso) | dfnsDifferenceInSeconds : today) > 0"
     *ngIf="post"
>
  <div *ngIf="(post.type==postTypePicture && !post.atHome) || (post.type == postTypeIdea)" class="post-type">
    <kz-icons name="idea"></kz-icons>
  </div>
  <div *ngIf="isPostTypeQuestion && post.medias.length" class="post-type">
    <span>?</span>
  </div>
  <div *ngIf="isPostTypeQuestion && !post.medias.length" class="post-type-question">
    <kz-icons name="post_question"></kz-icons>
    <span>J'ai une question</span>
  </div>

  <ng-template #postComponents let-post="post" let-options="options" let-isPostMemory="isPostMemory"  let-postParent="postParent">
    <ng-container *ngIf="(post.mood | getMood | async) as mood">
      <div class="kz-mood-container" aria-hidden="true">
        <kz-icons [name]="mood | getPostMoodIcon"></kz-icons>
        <kz-tooltip
          tooltipSize="small"
          tooltipArrowPosition="left-bottom"
          class="kz-mood--name "
        >{{mood.name}}</kz-tooltip>
      </div>
    </ng-container>

    <!--  Pictures -->
    <app-post-img
      *ngIf="!isPostTypeVideo && !isPostType360"
      [emptyPicture]="isPostTypeEvent && !post.medias.length"
      [post]="post"
      [linkToPost]="true"
      (openPost)="openPost((postParent) ? postParent : post)"
    ></app-post-img>
    <!--  Pictures -->

    <!-- Event -->
    <app-post-event
      *ngIf="isPostTypeEvent"
      [post]="post"
      [emptyPicture]="isPostTypeEvent && !post.medias.length"
    ></app-post-event>
    <!-- /Event -->

    <!-- Video -->
    <app-post-video
      *ngIf="isPostTypeVideo"
      [post]="post"
      (openPost)="openPost((postParent) ? postParent : post)"
    ></app-post-video>
    <!-- /Video -->

    <!--  Options -->
    <app-post-options
      *ngIf="options && (userLoggedIsAdmin || userLoggedIsPostAuthor)"
      [isAdmin]="userLoggedIsAdmin"
      [userLoggedIsPostAuthor]="userLoggedIsPostAuthor"
      [post]="post"
      (hasBeenDeleted)="hasBeenDeleted($event)"
      (updatedPost)="updatePost($event)"
    ></app-post-options>
    <!-- /Options -->
  </ng-template>

  <ng-container *ngIf="post.postMemory" [ngTemplateOutlet]="postMemory" [ngTemplateOutletContext]="{post: post.postMemory, postParent: post}">
  </ng-container>

  <ng-container *ngIf="!post.postMemory" [ngTemplateOutlet]="postComponents" [ngTemplateOutletContext]="{post: post,options: true}">
  </ng-container>


  <ng-template #postMemory let-post="post" let-postParent="postParent">
    <div class="kz-post__container--memories">

      <app-post-ago [date]="post.createdAt"></app-post-ago>

      <div class="kz-post__content--memories">
        <div class="kz-post__medias--memories" [attr.data-post-type]="(post.type==postTypePicture && !post.atHome)?'idea':post.type">
          <div *ngIf="(post.type==postTypePicture && !post.atHome) || (post.type == postTypeIdea)" class="post-type">
            <kz-icons name="idea"></kz-icons>
          </div>
          <div *ngIf="isPostTypeQuestion" class="post-type">
            <span>?</span>
          </div>
          <ng-container *ngTemplateOutlet="postComponents;context:{post: post,options: false, isPostMemory: true, postParent: postParent}" ></ng-container>

          <div class="kz-post-description">
            <div class="read-more-container read-more-collapsed-preview" *kzTextPlaceholder="!(postDescriptionLoading$ | async);nbLines:descriptionTranslatedNbLines" [innerHTML]="textMemory | hashtagHighlight | linkHighlight | pings: post['pings']"></div>
          </div>

          <!--  Survey -->
          <app-post-survey
            *ngIf="isPostTypeSurvey"
            [translationDisplayed]="descriptionTranslatedDisplayed"
            [post]="post"
            [userLoggedIsPostAuthor]="userLoggedIsPostAuthor"
            [initForm]="initSurveyForm"
          ></app-post-survey>
          <!--  Survey -->

          <span class="read-more-cta read-more-cta--memories" (click)="openPost(post, true)" i18n="@@share-component.read-more.showPost">Show the original post</span>

        </div>
      </div>

      <!--  Options -->
      <app-post-options
        [post]="postParent"
        *ngIf="userLoggedIsAdmin || userLoggedIsPostAuthor"
        [isAdmin]="userLoggedIsAdmin"
        [userLoggedIsPostAuthor]="userLoggedIsPostAuthor"
        (hasBeenDeleted)="hasBeenDeleted($event)"
        (updatedPost)="updatePost($event)"
      ></app-post-options>
    </div>
  </ng-template>

  <!--  Profil -->
  <app-post-profil
    [post]="post"
    [userLogged]="userLogged"
    [userLoggedIsPostAuthor]="userLoggedIsPostAuthor"
    [displayInGrid]="true"
  ></app-post-profil>
  <!-- /Profil -->

  <!--  Description -->
  <div class="kz-post-description">
    <div class="read-more-container" #container *kzTextPlaceholder="!(postDescriptionLoading$ | async);nbLines:descriptionTranslatedNbLines"   [innerHTML]="text | hashtagHighlight | linkHighlight | pings: post['pings']"></div>
  <!--  <span class="read-more-cta" *ngIf="isCollapsed" (click)="toggleView()" i18n="@@share-component.read-more.showMore">Show more</span>-->
    <div *ngIf="canBeTranslated && !(postDescriptionLoading$ | async)" class="translation-actions">
      <span *ngIf="descriptionTranslatedDisplayed" (click)="translateDescription(false);" i18n="@@google-translate.original">See original</span>
      <span *ngIf="!descriptionTranslatedDisplayed" (click)="translateDescription();" i18n="@@google-translate.translate">Translate</span>
    </div>
  </div>
  <!-- /Description -->

  <!--  Survey -->
  <app-post-survey
    *ngIf="isPostTypeSurvey"
    [translationDisplayed]="descriptionTranslatedDisplayed"
    [post]="post"
    [userLoggedIsPostAuthor]="userLoggedIsPostAuthor"
    [initForm]="initSurveyForm"
  ></app-post-survey>
  <!--  Survey -->

  <!--  Details -->
  <app-post-details
    [post]="post"
    [userLoggedIsPostAuthor]="userLoggedIsPostAuthor"
    [userLoggedIsAdmin]="userStoreService.isAdminStore | async"
    [signedInUser]="userStoreService.userStore | async"
    (favoriteAdded)="favoriteAdded.emit($event)"
    (favoriteRemoved)="favoriteRemoved.emit(post['@id'])"
  ></app-post-details>
  <!-- /Details -->

  <!--  Discussion -->
  <app-post-discussion
    [post]="post"
    [displayTranslatedComments]="descriptionTranslatedDisplayed"
    [updateList]="updateCommentList | async"
  ></app-post-discussion>
  <!-- /Discussion -->
</div>
